import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DisplayTooltip = ({
  displayAddress,
  owner,
}: {
  displayAddress: string;
  owner: string;
}) => {
  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {displayAddress}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <p className="text-pink p-0 mb-0 fs-4">
        {" "}
        <a
          className="text-pink ms-1"
          target="_blank"
          href={`https://etherscan.io/address/${owner}`}
          rel="noreferrer"
        >
          {" "}
          {`${displayAddress.substring(0, 7)}...`}
        </a>
      </p>
    </OverlayTrigger>
  );
};

export default DisplayTooltip;
